import React from 'react';

export default function CategoriesTopbarWidget({ totalCount, showDelete, onToggleDelete }) {
    return (
        <div className="box-header with-border">
            <h3 className="box-title mt-5 cms-categories-title">
                Post categories
                {typeof totalCount === 'number' && (
                    <span className="cms-categories-title-count">({totalCount})</span>
                )}
            </h3>
            <a href="/cms/categories" title="Add New Category" className="btn btn-cm pull-right">
                <i className="fa fa-plus"></i>
            </a>
            <button
                type="button"
                title={showDelete ? 'Hide Delete Button' : 'Show Delete Button'}
                className="btn btn-cm margin-r-5 pull-right"
                onClick={onToggleDelete}
            >
                <i className="fa fa-trash"></i>
            </button>
        </div>
    );
}
